import Component from './TikTokAnalyticsPublicChart.vue'
export default Component
